var _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.905 11.6814C8.68788 11.6814 8.54297 11.826 8.54297 12.0434C8.54297 12.2605 8.68763 12.4054 8.905 12.4054H21.2106V14.9389L23.9975 11.9349L21.2109 9.14795V11.6814L8.905 11.6814Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.32422 1.84824H13.5467C14.275 1.84824 14.8655 2.43866 14.8655 3.16699V5.88582H16.2655V3.16699C16.2655 1.66547 15.0482 0.448242 13.5467 0.448242H3.32422C1.82269 0.448242 0.605469 1.66547 0.605469 3.16699V20.8932C0.605469 22.3948 1.82269 23.612 3.32422 23.612H13.5467C15.0482 23.612 16.2655 22.3948 16.2655 20.8932V17.3046H14.8655V20.8932C14.8655 21.6216 14.275 22.212 13.5467 22.212H3.32422C2.59589 22.212 2.00547 21.6216 2.00547 20.8932V3.16699C2.00547 2.43867 2.59589 1.84824 3.32422 1.84824Z",
    fill: "#555555"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7195,
    cy: 17.3045,
    r: 0.54375,
    fill: "#555555"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.7195,
    cy: 5.88555,
    r: 0.54375,
    fill: "#555555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.6462227d0023d386b3611759855459f8.svg";
export { ForwardRef as ReactComponent };